// @flow
import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import theme from '../../theme-config';

export default class Separator extends Component<Props> {
  styles = getStyles();

  render() {
    const styles = this.styles;
    const { color } = this.props;
    return (
      <View style={[styles.container, this.props.containerStyle]}>
        <View style={[styles.line, !!color && { backgroundColor: color }]} />
        {this.props.text && <Text style={[styles.text, !!color && { color }]}>{this.props.text}</Text>}
        {this.props.text && <View style={[styles.line, color && { backgroundColor: color }]} />}
      </View>
    );
  }
}

type Props = {
  text?: string,
  color?: string,
  containerStyle?: any,
};

const getStyles = () =>
  StyleSheet.create({
    container: {
      alignSelf: 'stretch',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'row',
    },
    line: {
      height: 1,
      flex: 1,
      backgroundColor: theme.primaryColor,
      opacity: 0.5,
    },
    text: {
      color: theme.primaryColor,
      fontSize: 20,
      textAlign: 'center',
      marginHorizontal: 20,
    },
  });
